import { render, staticRenderFns } from "./NDEConfectionHeaderForm.vue?vue&type=template&id=6b2c3780&"
import script from "./NDEConfectionHeaderForm.vue?vue&type=script&lang=js&"
export * from "./NDEConfectionHeaderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports